import { Injectable } from '@angular/core';

function _window(): any {
  // return the global native browser window object
  return window;
}

/**
 * Native window reference
 *
 * Usage:
 * <code><pre>
 * // Individual module import
 * import { WindowReference } from 'patternfly-ng/utilities';
 * // Or
 * import { WindowReference } from 'patternfly-ng';
 */

export class WindowReference {
  get nativeWindow(): any {
    return _window();
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
